import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=31e82bda&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=31e82bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e82bda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e82bda')) {
      api.createRecord('31e82bda', component.options)
    } else {
      api.reload('31e82bda', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=31e82bda&scoped=true&", function () {
      api.rerender('31e82bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qhI52aAyh9ts/JS/comp/SearchFilterTokens.vue"
export default component.exports